import { render, staticRenderFns } from "./EditNotesModalNew.vue?vue&type=template&id=44940176&scoped=true"
import script from "./EditNotesModalNew.vue?vue&type=script&lang=ts"
export * from "./EditNotesModalNew.vue?vue&type=script&lang=ts"
import style0 from "./EditNotesModalNew.vue?vue&type=style&index=0&id=44940176&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44940176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44940176')) {
      api.createRecord('44940176', component.options)
    } else {
      api.reload('44940176', component.options)
    }
    module.hot.accept("./EditNotesModalNew.vue?vue&type=template&id=44940176&scoped=true", function () {
      api.rerender('44940176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EditNotesModalNew.vue"
export default component.exports